module.exports = " <div> <div class=my-gallery :class=album_class> <a :href=image.src v-for=\"image,key in images\"> <img :src=image.src alt=\"\" :title=image.title :class=image_class /> </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
// module id = 11
// module chunks = 0